if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('click', (event) => {
          const closeButton = event.target.closest('[aria-label="Close"]');
          if (closeButton) {
            event.preventDefault();
            this.hidePopup();
          }
        });
      }

      hide() {
        //alert('asdfasdf');
        //super.hide();
      }

      hidePopup() {
        super.hide();
      }

      show(opener) {
        const li = opener.closest('li');
        const slideIndex = li
          ? Array.from(li.parentNode.children).indexOf(li)
          : 0;
        const swiperEl = this.querySelector('.product-media-swiper');
        if (!swiperEl || !swiperEl.swiper) return;
        setTimeout(() => {
          swiperEl.swiper.update();
          swiperEl.swiper.updateSlides();
          swiperEl.swiper.updateSize();
          swiperEl.swiper.slideToLoop(slideIndex, 0);
        }, 50);
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
